import React from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import ServiceCard from "../../../components/Service/ServiceCard";
import { Link } from "react-router-dom";

import { FaDocker, FaCloud, FaShieldAlt, FaRocket, FaChartBar, FaCogs, FaServer, FaCodeBranch } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/sssss.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";
import IndustriesSection from "../../home/IndustriesSection";

const serviceCards = [
    {
        icon: <FaCodeBranch size={80} color="var(--brand-primary)" />,
        title: "CI/CD Pipeline Design",
        description: "Automated build, test, and deployment pipelines that accelerate delivery while maintaining quality. We implement GitOps workflows with automated testing and security scanning at every stage.",
    },
    {
        icon: <FaShieldAlt size={80} color="var(--brand-primary)" />,
        title: "Security Integration",
        description: "Shift-left security with automated vulnerability scanning, secret management, and compliance checks. We embed security into your pipeline so issues are caught early and fixed fast.",
    },
    {
        icon: <FaCloud size={80} color="var(--brand-primary)" />,
        title: "Cloud Infrastructure Automation",
        description: "Infrastructure as Code (IaC) using Terraform, CloudFormation, or Pulumi. We automate provisioning, configuration, and management of cloud resources for consistency and repeatability.",
    },
    {
        icon: <FaDocker size={80} color="var(--brand-primary)" />,
        title: "Container Orchestration",
        description: "Kubernetes and Docker container management for scalable, resilient deployments. We design container strategies that simplify operations and improve resource utilization.",
    },
    {
        icon: <FaChartBar size={80} color="var(--brand-primary)" />,
        title: "Monitoring & Observability",
        description: "Comprehensive monitoring with Prometheus, Grafana, and ELK stack. We provide real-time visibility into system health, performance metrics, and application behavior.",
    },
    {
        icon: <FaRocket size={80} color="var(--brand-primary)" />,
        title: "Release Management",
        description: "Blue-green deployments, canary releases, and feature flags for safe, controlled rollouts. We minimize downtime and enable quick rollbacks when needed.",
    },
    {
        icon: <FaServer size={80} color="var(--brand-primary)" />,
        title: "Platform Engineering",
        description: "Build internal developer platforms that abstract complexity and improve developer experience. We create self-service tools that accelerate development without sacrificing control.",
    },
    {
        icon: <FaCogs size={80} color="var(--brand-primary)" />,
        title: "Reliability Engineering",
        description: "SRE practices including SLOs, error budgets, and incident response. We help you build systems that are reliable, scalable, and maintainable under production load.",
    },
];

const DevSecOpsPlatformEngineering = () => {
    return (
        <React.Fragment>
            <Helmet>
                <link rel="icon" href={favIcon} />
                <title>DevSecOps & Platform Engineering - Syrol Tech</title>
                <meta name="description" content="Secure CI/CD pipelines, cloud infrastructure, automation, and reliability engineering that enable fast, stable, and secure product delivery." />
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="pages"
                secondParentMenu="others"
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
                CanvasLogo={Logo}
                mobileNormalLogo={Logo}
                CanvasClass="right_menu_togle hidden-md"
                headerClass="full-width-header header-style1 home8-style4"
                TopBar="enable"
                TopBarClass="topbar-area home8-topbar"
                emailAddress="hello@syroltech.com"
                Location="Abuja, Nigeria"
            />
            <SiteBreadcrumb
                pageTitle="DevSecOps & Platform Engineering"
                pageName="DevSecOps & Platform Engineering"
                breadcrumbsImg={bannerbg}
            />
            <section className="consultation-hero-section position-relative w-100" style={{ minHeight: '420px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `url(${bannerbg}) center/cover no-repeat` }}>
                <div className="hero-overlay" style={{ position: 'absolute', inset: 0, background: 'rgba(10, 18, 32, 0.72)', zIndex: 1 }}></div>
                <div className="container position-relative" style={{ zIndex: 2, maxWidth: '900px', padding: '3rem 1rem', textAlign: 'left' }}>
                    <h1 style={{ color: '#fff', fontWeight: 700, fontSize: '2.6rem', lineHeight: 1.15, marginBottom: '1.2rem' }}>Accelerate delivery with secure automation</h1>
                    <p style={{ color: '#fff', fontSize: '1.25rem', maxWidth: '600px', marginBottom: '2.2rem' }}>Secure CI/CD pipelines, cloud infrastructure, automation, and reliability engineering that enable fast, stable, and secure product delivery.</p>
                    <Link to="/consultation" className="readon orange-btn" style={{ padding: '12px 28px', fontSize: '1rem', borderRadius: '6px', fontWeight: 700, textDecoration: 'none', display: 'inline-block', transition: 'background 0.2s' }}>Request A Free Proposal</Link>
                </div>
            </section>
            <div className="rs-contact style1 event-bg pt-110 md-pt-10 pb-100 md-pb-80">
                <div className="container pb-66 md-pb-46">
                    <h2 className="service-title mb-32">Our DevSecOps & Platform Engineering Services</h2>
                    {serviceCards.map((card, idx) => (
                        <ServiceCard
                            key={idx}
                            icon={card.icon}
                            title={card.title}
                            description={card.description}
                        />
                    ))}
                </div>
            </div>
            <IndustriesSection />
            <Newsletter
                sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
                titleClass="title mb-0 white-color"
            />
            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />
            <SearchModal />
            <ScrollToTop scrollClassName="scrollup orange-color" />
        </React.Fragment>
    );
};

export default DevSecOpsPlatformEngineering;
